const BASE = process.env.NEXT_PUBLIC_BASE_PATH ?? '';

async function refreshAccessToken(): Promise<string | null> {
  const refreshToken = localStorage.getItem('klugcmms-refresh-token');
  if (!refreshToken) return null;
  try {
    const res = await fetch(`${BASE}/api/auth/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refreshToken }),
    });
    if (!res.ok) return null;
    const json = await res.json();
    const newToken: string = json.data?.accessToken;
    const newRefresh: string = json.data?.refreshToken;
    if (!newToken) return null;
    localStorage.setItem('klugcmms-access-token', newToken);
    if (newRefresh) localStorage.setItem('klugcmms-refresh-token', newRefresh);
    return newToken;
  } catch {
    return null;
  }
}

export async function apiRequest(path: string, options: RequestInit = {}, retry = true): Promise<Response> {
  const token = typeof window !== 'undefined' ? localStorage.getItem('klugcmms-access-token') : null;

  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers ?? {}),
    },
  });

  // Auto-refresh on 401 and retry once
  if (res.status === 401 && retry && typeof window !== 'undefined') {
    const newToken = await refreshAccessToken();
    if (newToken) return apiRequest(path, options, false);
    // Refresh failed — clear tokens and redirect to login
    localStorage.removeItem('klugcmms-access-token');
    localStorage.removeItem('klugcmms-refresh-token');
    localStorage.removeItem('klugcmms-user');
    window.location.href = `${BASE}/sign-up-login`;
    return res;
  }

  return res;
}
